import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React from 'react';
import {
  DateTimeFieldsRow,
  DateTimePickerWrapper,
} from '../FormPreview.styles';
import { DatePickerField } from './DatePickerField';
import { BaseInputProps } from './types';

export const DateTimeInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
}) => {
  const showDatePicker = currentQuestion.dateTimeOptions?.datePicker ?? true;
  const showTimePicker = currentQuestion.dateTimeOptions?.timePicker ?? false;
  const showSeconds = currentQuestion.dateTimeOptions?.showSeconds ?? true;

  const dateValue = answers[currentQuestion.id]?.date || '';
  const timeValue = answers[currentQuestion.id]?.time || '';

  const timeAsDate = timeValue ? dayjs(`2000-01-01T${timeValue}`) : null;

  const [isTimePickerOpen, setIsTimePickerOpen] = React.useState(false);

  const handleTimeChange = (newValue: dayjs.Dayjs | null) => {
    if (!newValue) return;
    const formatted = showSeconds
      ? newValue.format('HH:mm:ss')
      : newValue.format('HH:mm');
    dispatch({
      type: 'SET_TIME',
      questionId: currentQuestion.id,
      payload: formatted,
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimeFieldsRow data-testid="form-preview-datetime-container">
        {showDatePicker && (
          <DateTimePickerWrapper $isDateWithTime={showTimePicker}>
            <DatePickerField
              value={dateValue}
              usePortal
              onChange={(isoDate) =>
                dispatch({
                  type: 'SET_DATE',
                  questionId: currentQuestion.id,
                  payload: isoDate,
                })
              }
              data-testid="form-preview-date-display"
            />
          </DateTimePickerWrapper>
        )}

        {showTimePicker && (
          <DateTimePickerWrapper>
            <TimePicker
              open={isTimePickerOpen}
              onOpen={() => setIsTimePickerOpen(true)}
              onClose={() => setIsTimePickerOpen(false)}
              value={timeAsDate}
              onChange={handleTimeChange}
              views={
                showSeconds
                  ? ['hours', 'minutes', 'seconds']
                  : ['hours', 'minutes']
              }
              format={showSeconds ? 'hh:mm:ss a' : 'hh:mm a'}
              slotProps={{
                textField: {
                  fullWidth: true,
                  onClick: () => setIsTimePickerOpen(true),
                  inputProps: { readOnly: true },
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ...({ 'data-testid': 'form-preview-time-display' } as any),
                },
                popper: {
                  container:
                    document.querySelector<HTMLElement>(
                      '[data-testid="form-preview-slideout"]',
                    ) || document.body,
                },
              }}
            />
          </DateTimePickerWrapper>
        )}
      </DateTimeFieldsRow>
    </LocalizationProvider>
  );
};
